/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteBusinessResponse } from '../../models/delete-business-response';

export interface DeleteBusiness$Params {
  business_id: string;
}

export function deleteBusiness(http: HttpClient, rootUrl: string, params: DeleteBusiness$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteBusinessResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteBusiness.PATH, 'delete');
  if (params) {
    rb.path('business_id', params.business_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteBusinessResponse>;
    })
  );
}

deleteBusiness.PATH = '/business/{business_id}';
